angular.module('bbl.services.auth', [])
  .factory('Auth', ['$http', '$q', '$window', 'API', 'Api', 'pubsub', '$cookies', AuthServiceFactory]);

var formHeaders = {
  headers: {'Content-Type': 'application/x-www-form-urlencoded'}
};

function getUserData(response) {
  var userData = response ? response.data['user-data'] : {},
    profile = userData.profile || {};

  return {
    id: profile.id,
    username: profile.username,
    home_time_zone: profile.home_time_zone,
    company: userData.company,
    first_name: profile.first_name,
    last_name: profile.last_name,
    plan: userData.plan,
    plivo_username: userData.plivo_username,
    plivo_password: userData.plivo_password
  };
}

var evTypes = {
  LOGGED_IN: 'auth.loggedin',
  LOGGED_OUT: 'auth.loggedout',
};

function AuthServiceFactory($http, $q, $window, API, Api, pubsub, $cookies) {
  var userInfo = {}, clearCache = true;

  var _fromLocal = function getUserFromLocalStorage() {
    return JSON.parse($window.localStorage.getItem('userInfo') || '{}');
  };

  function getUserInfo() {
    angular.extend(userInfo, _fromLocal());

    return fetchUser(clearCache).then(function(user) {
      return angular.extend(userInfo, user);
    });
  }

  function _fetchUser(noCache) {
    return $http.get(API.profile, {cache: !noCache})
    .then(function(response) { return response.data.objects[0]; });
  }

  function fetchUser(noCache) {
    var userQuery = _fetchUser(noCache),
      companyQuery = getCompanyInfo(noCache),
      planQuery = getPlan(noCache);

    return $q.all([userQuery, companyQuery, planQuery]).then(function(response) {
      clearCache = false;
      var user = response[0], company = response[1], plan = response[2];
      user.company = company;
      user.plan = plan.data.plan;
      return user;
    });
  }

  function saveUserInfo(user) {
    var userData = angular.copy(user);

    delete userData.company;
    $window.localStorage.userInfo = JSON.stringify(userData);

    getUserInfo();
    return userInfo;
  }

  function tryLogin(data, params) {
    var opts = angular.extend({}, {
      method: 'POST',
      headers: formHeaders.headers,
      data: $.param(data),
      url: API.login,
    }, params);

    return $http(opts).then(onLoggedin);
  }

  function loginWithUrlAuthToken(token) {
    return tryLogin({url_auth_token: token}, {
      method: 'GET',
      url: '/accounts/api/v1/auth_token?url_auth_token=' + token
    });
  }

  function login(username, password) {
    clearCache = true;
    Api.clearCache();
    return tryLogin({username: username, password: password});
  }

  function loginWith(data) {
    clearCache = true;
    Api.clearCache();
    return tryLogin(data);
  }

  function logout() {
    return $http.get(API.logout).then(function() {
      $window.localStorage.clear();
      $window.sessionStorage.clear();
      angular.extend(userInfo, getUserData());
      clearCache = true;
      Api.clearCache();
      $cookies.remove('impersonating');

      pubsub.pub(evTypes.LOGGED_OUT);
      return $q.reject({ authenticated: false });
    });
  }

  function forgotPassword(email) {
    var data = $.param({email: email});
    return $http.post(API.password_forgot, data, formHeaders);
  }

  function resetPassword(key, new_password, new_password_again) {
    var data = $.param({
      key: key,
      new_password: new_password,
      new_password_again: new_password_again
    });

    return $http.post(API.password_reset, data, formHeaders)
      .then(getUserData).then(saveUserInfo);
  }

  function changePassword(password_1, password_2) {
    var data = $.param({
      password_1: password_1,
      password_2: password_2
    });

    return $http.post(API.password_change, data, formHeaders);
  }

  function signup(attrs) {
    return $http.post(API.signup, $.param(attrs), formHeaders)
      .then(getUserData).then(saveUserInfo);
  }

  function changePlan(attrs) {
    return $http.post(API.plans_change, $.param(attrs), formHeaders)
    .then(function(response) {
        var userInfoClean = $window.localStorage.userInfo.replace(/\\054/g, ',');
        var userData = JSON.parse(userInfoClean);
        userData.plan = response.data.plan;
        return saveUserInfo(userData);
    });
  }

  function getPlan(noCache) {
    return $http.get(API.plans_getCurrent, {cache: !noCache});
  }

  function getCards() {
    return $http.get(API.cards_list)
    .then(function(response) {
      return response.data.cards;
    });
  }

  function addCard(attrs) {
    return $http.post(API.cards_set, $.param(attrs), formHeaders);
  }

  function removeCard(idCard) {
    return $http.post(API.cards_remove+idCard+'/', $.param({}), formHeaders);
  }

  function setDefaultCard(idCard) {
    return $http.post(API.cards_set_default+idCard+'/', $.param({}), formHeaders);
  }

  function cancelPlan(data) {
    var reason = {};

    if(data) {
      reason = {
        optionId: data.id,
        optionText: data.question,
        answer: data.answer,
      };
    }

    return $http.post(API.plans_cancel, $.param(reason), formHeaders)
    .then(function(response) {
      var userData = JSON.parse($window.localStorage.userInfo);
      userData.plan = {};
      return saveUserInfo(userData);
    });
  }

  function getProfile() {
    return $http.get(API.profile_get);
  }

  function setProfile(attrs) {
    var userData = _fromLocal();
    userData.username = attrs.email;
    userData.first_name = attrs.first_name;
    userData.last_name = attrs.last_name;
    saveUserInfo(userData);

    return $http.post(API.profile_update, $.param(attrs), formHeaders);
  }

  function getCompanyInfo(noCache) {
    return $http.get(API.company, {cache: !noCache})
    .then(function(response) {
      return response.data.objects[0];
    });
  }

  function updateCompanyInfo(data){
    return $http.post(API.company_update, $.param(data), formHeaders)
    .then(function(response) {
      return response.data;
    });
  }

  function impersonation(username) {
    var data = $.param({username: username});

    if (!$cookies.get('_last')) {
      $cookies.put('_last', userInfo.username);
    }

    return $http.post(API.impersonate, data, formHeaders)
    .then(function(response) {
      pubsub.pub(evTypes.LOGGED_OUT);

      return response;
    })
    .then(onLoggedin);
  }

  function exitImpersonation() {
    return impersonation($cookies.get('_last'))
      .then(function() {
        $cookies.remove('_last');
        $cookies.remove('impersonating');
      });
  }

  function onLoggedin(response) {
    if (response.data.success) {
      // Update the local storage data.
      $window.localStorage.clear();

      clearCache = true;
      Api.clearCache();
      saveUserInfo(getUserData(response));
      pubsub.pub(evTypes.LOGGED_IN, userInfo);
    }

    return response;
  }

  function getSubUsers() {
    return $http.get(API.subusers);
  }

  function updateSubuser(attrs) {
    return $http.post(API.subusers_update, $.param(attrs), formHeaders);
  }

  function inviteSubuser(attrs) {
    return $http.post(API.subusers_invite, $.param(attrs), formHeaders);
  }

  function createSubuser(uuid, password) {
    var data = $.param({password: password});

    return $http.post(API.subusers_create+uuid+'/', data, formHeaders)
    .then(getUserData).then(saveUserInfo);
  }

  function deleteSubuser(id) {
    return $http.get(API.subusers_delete + id + '/');
  }

  function getPermission(noCache) {
    return $http.get(API.permissions, {cache: !noCache});
  }

  return {
    userInfo: userInfo,
    getUserInfo: getUserInfo,
    fetchUser: fetchUser,
    login: login,
    loginWith: loginWith,
    logout: logout,
    forgotPassword: forgotPassword,
    changePassword: changePassword,
    resetPassword: resetPassword,
    signup: signup,
    changePlan: changePlan,
    getPlan: getPlan,
    getCards: getCards,
    addCard: addCard,
    removeCard: removeCard,
    setDefaultCard: setDefaultCard,
    cancelPlan: cancelPlan,
    getProfile: getProfile,
    setProfile: setProfile,
    getCompanyInfo: getCompanyInfo,
    impersonation: impersonation,
    exitImpersonation: exitImpersonation,
    getSubUsers: getSubUsers,
    updateSubuser: updateSubuser,
    inviteSubuser: inviteSubuser,
    createSubuser: createSubuser,
    deleteSubuser: deleteSubuser,
    getPermission: getPermission,
    updateCompanyInfo: updateCompanyInfo,
    loginWithUrlAuthToken: loginWithUrlAuthToken,
    evTypes: evTypes,
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/auth-service.js
 ** module id = 156
 ** module chunks = 0
 **/